import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Import actions
import { removeNpvrRecordingsItem, fetchNpvrRecordings } from 'store/actions';

// Import components
import { Alert } from 'components/elements';
import { Button } from 'components/elements/atoms/Button/Button';

// Import hooks
import { useAppSelector, useAppDispatch } from 'store/hooks';

type Props = {
	closeModal: VoidFunction;
	recordingId: number;
};

const DeleteRecording = ({ closeModal, recordingId }: Props) => {
	const { t } = useTranslation();
	const dispatch = useAppDispatch();

	const {
		remove: { isLoading, isError, errorMessage }
	} = useAppSelector(({ recordingsNpvr }) => recordingsNpvr);

	const handleSubmit = async () => {
		await removeNpvrRecordingsItem(recordingId, () => {
			fetchNpvrRecordings()(dispatch);
			closeModal();
		})(dispatch);
	};

	return (
		<>
			<Button disabled={isLoading} isLoading={isLoading} onClick={handleSubmit} variant="primary" modifiers="contained">
				{t('user_profile_recordings_submit')}
			</Button>
			{isError && <Alert closeBtn={false} text={errorMessage || t('common_errors_connection')} />}
		</>
	);
};

DeleteRecording.propTypes = {
	closeModal: PropTypes.func.isRequired,
	recordingId: PropTypes.number.isRequired
};

export default DeleteRecording;
